import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { LoggingService } from '@domgen/dgx-fe-logging';
import { SUPPORT_CONFIG } from '@support/util-models';

export const privacyPolicyGuard: CanActivateFn = (route, state): boolean => {
  const supportConfig = inject(SUPPORT_CONFIG, { optional: true });
  const loggingService = inject(LoggingService);

  loggingService.debug('privacyPolicyGuard', 'Start');

  if (
    state.url === '/support/privacy-policy' &&
    supportConfig?.privacyPolicyRedirect
  ) {
    loggingService.debug('privacyPolicyGuard', 'Finish');
    window.location.href = supportConfig.privacyPolicyRedirect;
    return false;
  }

  return true;
};
